export const FETCH_LANDING_ASSETS = 'FETCH_LANDING_ASSETS';
